<template>
  <b-container>
    <b-row class="m-4">
      <b-col class="offset-md-3">
        <section-title class="h1">
          {{ $t("404-error-title") }}
        </section-title>
        <div v-html="$t('404-error-description')"></div>
        <b-btn to="/home" variant="primary" size="sm" class="mr-2">
          {{ $t("404-error-redirect-button") }}
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SectionTitle from "../SectionTitle.vue";
import { mapState } from "vuex";

export default {
  components: {
    SectionTitle
  },
  computed: {
    ...mapState("auth", ["user"]),
    isConnected() {
      return this.user.token ? true : false;
    }
  }
};
</script>
